__turbopack_context__.v({
  "addressBlock": "Form-module-scss-module___Q6dsa__addressBlock",
  "button": "Form-module-scss-module___Q6dsa__button",
  "checkLabel": "Form-module-scss-module___Q6dsa__checkLabel",
  "checkbox": "Form-module-scss-module___Q6dsa__checkbox",
  "checkmark": "Form-module-scss-module___Q6dsa__checkmark",
  "contact": "Form-module-scss-module___Q6dsa__contact",
  "contactForm": "Form-module-scss-module___Q6dsa__contactForm",
  "contactInner": "Form-module-scss-module___Q6dsa__contactInner",
  "error": "Form-module-scss-module___Q6dsa__error",
  "errorMessage": "Form-module-scss-module___Q6dsa__errorMessage",
  "hasError": "Form-module-scss-module___Q6dsa__hasError",
  "headline": "Form-module-scss-module___Q6dsa__headline",
  "inlineRadioGroup": "Form-module-scss-module___Q6dsa__inlineRadioGroup",
  "input": "Form-module-scss-module___Q6dsa__input",
  "inputWrapper": "Form-module-scss-module___Q6dsa__inputWrapper",
  "isDefault": "Form-module-scss-module___Q6dsa__isDefault",
  "message": "Form-module-scss-module___Q6dsa__message",
  "nameBlock": "Form-module-scss-module___Q6dsa__nameBlock",
  "productSelects": "Form-module-scss-module___Q6dsa__productSelects",
  "select": "Form-module-scss-module___Q6dsa__select",
  "submitRow": "Form-module-scss-module___Q6dsa__submitRow",
  "successMessage": "Form-module-scss-module___Q6dsa__successMessage",
});
